import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, OnInit, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom, Subscription } from 'rxjs';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';
import { PermissaoAcessoService } from '../../services/permissao-acesso.service';
import { PedidoVendaComponent } from '../pedido-venda/pedido-venda.component';

interface PedidoLinha {
  nunota:          number;
  numTitulo?:      string;
  codemp:          number;
  dtmov:           string;
  cliente:         string;
  docparc:         string;
  empresa:         string;
  aeronave:        string;
  vlrnota:         number;
  vlrmoeda:        number;
  vlrfrete:        number;
  vlripi:          number;
  vlrst:           number;
  vlrcoreusd:      number;
  status:          string;
  statusnotaRaw:   string; // código Sankhya: P, L, A, C
  vendedor:        string;
  tipoOperacao:    string;
  codTipOper:      number;
  observacao:      string;
  obsInterna?:     string; // AD_OBSINT — só populado se o doListarPedidos do addon retornar essa coluna
  qtdItens?:       number; // Mapeado caso o backend retorne
  podeDesm?:       boolean; // true se qtdItens>1 OU (qtdItens===1 e qty>1)
  temFluxo?:       boolean;
  jaDesmembrou?:   boolean;
  gplStatus?:      string; // 'ABERTO' | 'AUTORIZADO' | 'PENDENTE' | 'REPROVADO' | 'SEPARACAO' | 'SEPARACAO TOTAL' | 'CONFERENCIA' | 'PENDENCIA VENDEDOR' | 'LOGISTICA' | 'PRONTO' | 'FINALIZADO' | 'CANCELADO' | ''
}

interface PedidoDetalhe extends PedidoLinha {
  obsInterna: string;
  numPedido2: string;
  cifFob:     string;
  formaEnvio: string;
  pesoBruto:  number;
  vlrFrete:   number;
  itens:      DetalheItem[];
}

interface DetalheItem {
  seq:       number;
  codprod:   number;
  descricao: string;
  qtd:       number;
  vlrunit:   number;
  vlrtot:    number;
  vlrdesc:   number;
  percdesc:  number;
  codvol:    string;
}

// @ts-ignore
export interface FluxoNode {
  nunota: number;
  nunotaOrig: number | null;
  ehSelecionada: boolean;
  ehRaiz: boolean;
  dtmov: string;
  status: string;
  nomeparc: string;
  codemp: number;
  filhos: FluxoNode[];
}

@Component({
  selector: 'app-pedido-venda-lista',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule, PedidoVendaComponent],
  templateUrl: './pedido-venda-lista.component.html',
  styleUrl: './pedido-venda-lista.component.css'
})
export class PedidoVendaListaComponent implements OnInit, OnDestroy {

  @Output() novoPedido        = new EventEmitter<void>();
  @Output() editarPedido      = new EventEmitter<number>();
  @Output() imprimirPedido    = new EventEmitter<number>();
  @Output() solicitarDuplicar   = new EventEmitter<number>();
  @Output() solicitarDividir    = new EventEmitter<number>();
  @Output() solicitarTransferir = new EventEmitter<{ nunota: number; codemp: number }>();
  @Output() solicitarFluxo      = new EventEmitter<number>();
  @Output() solicitarTransporte  = new EventEmitter<number>();
  @Output() solicitarAnexos      = new EventEmitter<number>();
  @Output() solicitarAutorizar   = new EventEmitter<number>();
  /** Disparado quando o usuário clica em Autorizar mas o botão está bloqueado
   *  (TOP/status não elegível) — antes o clique não fazia NADA nesse caso
   *  (pointer-events:none só deixava um tooltip no hover, fácil de nunca ver),
   *  então o usuário achava que o Autorizar estava simplesmente quebrado. */
  @Output() avisoAutorizarBloqueado = new EventEmitter<string>();
  @Output() solicitarGerarPedidoCompra = new EventEmitter<number>();
  @Output() solicitarGerarVendaOS      = new EventEmitter<void>();
  @Output() solicitarGerarVendaLegado  = new EventEmitter<void>();
  /** Cancelar (leve — só marca GPL_STATUS) e Estornar — não mexem na nota do
   *  Sankhya como o Excluir; o gateway decide o novo status/TOP e delega a
   *  gravação para a tela de Pedido de Venda, em segundo plano. */
  @Output() solicitarAlterarStatusGpl = new EventEmitter<{ nunota: number; novoGplStatus: string; novoCodTipOper?: number }>();

  // ── Menu de engrenagem (ações gerais da tela) ──────────────
  menuEngrenagemAberto = false;

  toggleMenuEngrenagem(event: Event): void {
    event.stopPropagation();
    this.fecharDropdown();
    this.menuEngrenagemAberto = !this.menuEngrenagemAberto;
  }

  fecharMenuEngrenagem(): void {
    this.menuEngrenagemAberto = false;
  }

  onGerarVendaOS(event: Event): void {
    event.stopPropagation();
    this.fecharMenuEngrenagem();
    this.solicitarGerarVendaOS.emit();
  }

  onGerarVendaLegado(event: Event): void {
    event.stopPropagation();
    this.fecharMenuEngrenagem();
    this.solicitarGerarVendaLegado.emit();
  }

  // ── Filtros ───────────────────────────────────────────────
  dtDe              = '';
  dtAte             = '';
  // Vem marcado por padrão; ao desmarcar, filtra pelo GPL_STATUS (ver
  // pedidosFiltrados) — o parâmetro mostrarCancelados enviado ao addon
  // reflete o cancelamento nativo do Sankhya, que é um conceito diferente
  // do nosso GPL_STATUS=CANCELADO (Cancelar leve), por isso não é
  // suficiente sozinho para escondê-los da lista.
  mostrarCancelados = true;

  // ── Lista ─────────────────────────────────────────────────
  carregando      = false;
  pedidos: PedidoLinha[] = [];
  erro            = '';

  // ── Busca/filtro ──────────────────────────────────────────
  termoBusca      = '';
  termoBuscaPn    = '';
  private _pnTimer: any = null;

  // ── Filtro de Fluxo (ativado pelo gateway via ViewChild) ──
  filtroFluxoNunotas: Set<number> | null = null;
  filtroFluxoLabel   = '';

  /** Aplica o filtro de fluxo: mostra somente os pedidos da cadeia informada. */
  aplicarFiltroFluxo(nunotas: number[], label: string): void {
    this.filtroFluxoNunotas = new Set(nunotas);
    this.filtroFluxoLabel   = label;
    this.paginaAtual        = 1;
  }

  /** Remove o filtro de fluxo e volta a mostrar todos os pedidos carregados. */
  limparFiltroFluxo(): void {
    this.filtroFluxoNunotas = null;
    this.filtroFluxoLabel   = '';
    this.paginaAtual        = 1;
  }

  // ── Paginação ─────────────────────────────────────────────
  paginaAtual     = 1;
  itensPorPagina  = 11;
  readonly opcoesPorPagina = [11, 25, 50, 100];

  get pedidosFiltrados(): PedidoLinha[] {
    // Separação por módulo — Venda: não mostra TOP 1000 (Orçamento = Pré-Venda).
    let lista = this.pedidos.filter(p => p.codTipOper !== 1000);
    // 0. "Exibir cancelados" desmarcado — filtra pelo nosso GPL_STATUS
    // (Cancelar leve), já que o mostrarCancelados do addon só cobre o
    // cancelamento nativo do Sankhya, não esse status próprio da tela.
    if (!this.mostrarCancelados) {
      lista = lista.filter(p => (p.gplStatus || '').toUpperCase() !== 'CANCELADO');
    }
    // 1. Filtro de fluxo (tem precedência sobre busca rápida)
    if (this.filtroFluxoNunotas) {
      lista = lista.filter(p => this.filtroFluxoNunotas!.has(p.nunota));
    }
    // 2. Busca rápida por texto (cliente/CNPJ/vendedor/prefixo) ou por NUNOTA
    const termo = this.termoBusca.trim().toLowerCase();
    if (termo) {
      lista = lista.filter(p =>
        (p.cliente   || '').toLowerCase().includes(termo) ||
        (p.docparc   || '').toLowerCase().includes(termo) ||
        (p.vendedor  || '').toLowerCase().includes(termo) ||
        (p.aeronave  || '').toLowerCase().includes(termo) ||
        String(p.nunota || '').includes(termo)
      );
    }
    return lista;
  }

  get totalPaginas(): number {
    return Math.max(1, Math.ceil(this.pedidosFiltrados.length / this.itensPorPagina));
  }

  get pedidosPagina(): PedidoLinha[] {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    return this.pedidosFiltrados.slice(inicio, inicio + this.itensPorPagina);
  }

  get paginas(): number[] {
    const total = this.totalPaginas;
    const atual = this.paginaAtual;
    const delta = 2;
    const range: number[] = [];
    for (let i = Math.max(1, atual - delta); i <= Math.min(total, atual + delta); i++) {
      range.push(i);
    }
    return range;
  }

  irParaPagina(p: number): void {
    if (p < 1 || p > this.totalPaginas) return;
    this.paginaAtual = p;
  }

  onItensPorPaginaChange(): void {
    this.paginaAtual = 1;
  }

  // ── Busca por NUNOTA fora do período/página carregados ─────
  private _nunotaTimer: any = null;
  buscandoPorNunota = false;
  nunotaNaoEncontrado: number | null = null;

  onTermoBuscaChange(): void {
    this.paginaAtual = 1;
    this.nunotaNaoEncontrado = null;
    clearTimeout(this._nunotaTimer);

    const termo = this.termoBusca.trim();
    // Só tenta a busca remota por NUNOTA quando o termo é só dígitos (com
    // algum tamanho mínimo, pra não disparar a cada dígito digitado) e não
    // achou nada na lista já carregada — evita round-trip desnecessário
    // quando o pedido já está visível (mesmo período/página).
    if (!/^\d{3,}$/.test(termo)) return;
    const jaEncontrado = this.pedidos.some(p => String(p.nunota) === termo);
    if (jaEncontrado) return;

    this._nunotaTimer = setTimeout(() => this._buscarPorNunota(Number(termo)), 500);
  }

  /** Busca o pedido diretamente pelo NUNOTA no addon (ignora filtro de data/página
   *  atuais) e, se encontrado, abre o modal de detalhe — cobre o caso do pedido
   *  estar fora do período "De/Até" selecionado na tela. */
  private async _buscarPorNunota(nunota: number): Promise<void> {
    if (!nunota || this.termoBusca.trim() !== String(nunota)) return;
    this.buscandoPorNunota = true;
    this.nunotaNaoEncontrado = null;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDetalhesPedidoVenda(nunota));
      const body = res?.responseBody ?? res;
      const encontrado = (body?.sucesso === true || body?.sucesso === 'true') && body?.detalhe;
      if (encontrado && this.termoBusca.trim() === String(nunota)) {
        this.detalhe = body.detalhe;
        this.detalheAberto = true;
      } else if (this.termoBusca.trim() === String(nunota)) {
        this.nunotaNaoEncontrado = nunota;
      }
    } catch {
      if (this.termoBusca.trim() === String(nunota)) {
        this.nunotaNaoEncontrado = nunota;
      }
    } finally {
      this.buscandoPorNunota = false;
    }
  }

  onTermoBuscaPnChange(): void {
    clearTimeout(this._pnTimer);
    this._pnTimer = setTimeout(() => this.buscar(), 500);
  }

  /** Total em R$: só VLRNOTA -- já inclui Core, Outros, Frete (quando "Incluso")
   *  e agora também IPI/ST (ver sincronização de TGFCAB.VLRIPI/VLRSUBST/VLRNOTA
   *  no motor nativo, PedidoVendaRepository). Somar vlripi/vlrst aqui de novo
   *  contaria em dobro -- por isso a lista usa VLRNOTA puro, sem somar nada. */
  vlrTotal(p: PedidoLinha): number {
    return p.vlrnota || 0;
  }

  /** Total em U$: VLRNOTA / cotação -- ver vlrTotal acima (VLRNOTA já é o total final). */
  vlrTotalUsd(p: PedidoLinha): number {
    const cotacao = p.vlrmoeda || 1;
    return (p.vlrnota || 0) / cotacao;
  }

  /** Total líquido (com desconto abatido) de um item no detalhe expandido do
   *  pedido -- TGFITE.VLRTOT agora é gravado CHEIO (sem abater desconto,
   *  mesmo padrão do resto do Sankhya -- ver GeraNotaFiscalHelper no addon),
   *  então reconstrói aqui o líquido pra a coluna "Total" continuar batendo
   *  com a coluna "Desc.%" ao lado. */
  itemTotalLiquido(it: DetalheItem): number {
    return (it.vlrtot || 0) - (it.vlrdesc || 0);
  }

  fmtBrl(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
  }

  fmtUsd(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' }).format(v);
  }

  onMostrarCanceladosChange(): void {
    this.buscar();
  }

  // ── Modal detalhe ─────────────────────────────────────────
  detalheAberto     = false;
  detalheCarregando = false;
  detalhe: PedidoDetalhe | null = null;

  // ── Cancelamento ──────────────────────────────────────────
  cancelando: number | null = null;
  confirmandoCancelamento: number | null = null;
  motivoCancelamento = '';
  erroCancelamento = '';
  motivosDisponiveis: string[] = [];
  carregandoMotivos = false;

  // ── Dropdown de ações ─────────────────────────────────────
  dropdownAberto:       number | null = null;
  statusSubMenuAberto:  number | null = null;
  pedidoSelecionado: number | null = null;
  /** true quando o menu de Ações da linha aberta não cabe abaixo do botão
   *  (perto do fim da tela) e por isso deve abrir para cima. */
  dropdownAbrirParaCima = false;
  /** Quando não-nulo, o menu de Ações abre ancorado nessa posição exata da
   *  tela (position: fixed) em vez de ancorado no botão "⋮" -- usado quando
   *  o botão direito é clicado em qualquer lugar da linha que não seja o
   *  próprio "⋮" (ver abrirMenuAcoesContexto). */
  dropdownPosFixa: { top: number; left: number } | null = null;

  // ── Fluxo de Desmembramento (Inline) ──────────────────────
  fluxoSelecionado: number | null = null;
  fluxoNos: FluxoNode[] = []; // Mantido para compatibilidade, caso necessário
  fluxoRaizes: FluxoNode[] = []; // A estrutura de árvore

  toggleDropdown(event: Event, p: PedidoLinha): void {
    event.stopPropagation();
    if (this.dropdownAberto === p.nunota) {
      this.dropdownAberto = null;
    } else {
      this.dropdownAberto = p.nunota;
      this.dropdownPosFixa = null; // aberto pelo botão "⋮" -- ancorado nele, não em posição fixa
      this.dropdownAbrirParaCima = this._deveAbrirDropdownParaCima(event);
      if (p.qtdItens === undefined) {
        this._carregarQtdItensSilencioso(p);
      }
    }
  }

  /** Botão direito do mouse numa linha: seleciona a linha (mesmo destaque
   *  visual do clique normal, linha-selecionada) e abre o MESMO menu de
   *  Ações que o botão "⋮" abre -- reaproveita 100% do menu/lógica
   *  existente, só troca o gatilho.
   *
   *  Posicionamento: se o clique direito caiu exatamente sobre o botão "⋮"
   *  (.btn-dots), mantém o comportamento ancorado nele (dropdownAbrirParaCima
   *  calculado a partir do próprio botão). Caso contrário, o clique caiu em
   *  qualquer outro ponto da linha, então o menu abre exatamente na posição
   *  do clique (dropdownPosFixa, position: fixed no template), clampada às
   *  bordas da tela pra não cortar. Pedidos cancelados não têm botão de
   *  Ações (mesma regra do template, *ngIf="!ehCancelado(p)") -- nesse caso
   *  só seleciona a linha, sem abrir menu nenhum. */
  async abrirMenuAcoesContexto(event: MouseEvent, p: PedidoLinha): Promise<void> {
    event.preventDefault(); // bloqueia o menu nativo do navegador
    event.stopPropagation();
    this.statusSubMenuAberto = null;

    if (this.pedidoSelecionado !== p.nunota) {
      this.pedidoSelecionado = p.nunota;
      await this._carregarFluxo(p.nunota);
    }

    if (this.ehCancelado(p)) {
      this.dropdownAberto = null;
      this.dropdownPosFixa = null;
      return;
    }

    const alvo = event.target as HTMLElement | null;
    const cliqueNoBotaoDots = !!alvo?.closest('.btn-dots');

    this.dropdownAberto = p.nunota;

    if (cliqueNoBotaoDots) {
      const linha = event.currentTarget as HTMLElement | null;
      const botao = linha ? (linha.querySelector('.btn-dots') as HTMLElement | null) : null;
      this.dropdownPosFixa = null;
      this.dropdownAbrirParaCima = botao ? this._deveAbrirDropdownParaCimaEl(botao) : false;
    } else {
      this.dropdownPosFixa = this._calcularPosicaoMenuNoClique(event);
      this.dropdownAbrirParaCima = false; // irrelevante em posição fixa -- já clampado na tela
    }

    if (p.qtdItens === undefined) {
      this._carregarQtdItensSilencioso(p);
    }
  }

  /** Calcula a posição (top/left em px, relativos à viewport) onde o menu de
   *  Ações deve abrir quando ancorado no ponto do clique, clampando pra não
   *  vazar pra fora da tela (direita/embaixo). */
  private _calcularPosicaoMenuNoClique(event: MouseEvent): { top: number; left: number } {
    const MENU_LARGURA_EST = 230;
    const MENU_ALTURA_EST = 420;
    const MARGEM = 8;
    let left = event.clientX;
    let top = event.clientY;
    if (left + MENU_LARGURA_EST > window.innerWidth) {
      left = window.innerWidth - MENU_LARGURA_EST - MARGEM;
    }
    if (top + MENU_ALTURA_EST > window.innerHeight) {
      top = window.innerHeight - MENU_ALTURA_EST - MARGEM;
    }
    if (left < MARGEM) left = MARGEM;
    if (top < MARGEM) top = MARGEM;
    return { top, left };
  }

  /** Verifica se há espaço suficiente abaixo do botão "Ações" para o menu
   *  abrir para baixo (comportamento padrão); perto do fim da tela, não há
   *  espaço, então o menu deve abrir para cima para não cortar itens. */
  private _deveAbrirDropdownParaCima(event: Event): boolean {
    const alvo = event.currentTarget as HTMLElement | null;
    return alvo ? this._deveAbrirDropdownParaCimaEl(alvo) : false;
  }

  private _deveAbrirDropdownParaCimaEl(alvo: HTMLElement): boolean {
    const rect = alvo.getBoundingClientRect();
    const espacoAbaixo = window.innerHeight - rect.bottom;
    const ALTURA_ESTIMADA_MENU = 400; // altura aproximada do menu com todos os itens
    return espacoAbaixo < ALTURA_ESTIMADA_MENU;
  }

  private async _carregarQtdItensSilencioso(p: PedidoLinha): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDetalhesPedidoVenda(p.nunota));
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        const detalhe = body.detalhe;
        const itens: DetalheItem[] = (detalhe && detalhe.itens) ? detalhe.itens : [];
        p.qtdItens = itens.length;
        p.podeDesm = itens.length > 1 || (itens.length === 1 && itens[0].qtd > 1);
      } else {
        p.qtdItens = 0;
      }
    } catch {
      p.qtdItens = 0; // fallback em caso de erro
    }
  }

  fecharDropdown(): void {
    this.dropdownAberto = null;
    this.dropdownPosFixa = null;
  }

  /** Fecha o dropdown de ações (e o submenu de status) ao clicar fora dele —
   *  o botão que abre e os itens do próprio menu já dão stopPropagation, então
   *  esse listener só é acionado por cliques realmente "fora" (tabela, tela, etc). */
  @HostListener('document:click')
  onDocumentClickFecharDropdown(): void {
    this.dropdownAberto = null;
    this.dropdownPosFixa = null;
    this.statusSubMenuAberto = null;
  }

  async selecionarLinha(event: Event, nunota: number): Promise<void> {
    event.stopPropagation();
    // O clique na linha também dá stopPropagation, então não bubbla até o
    // document:click que fecha o dropdown de ações — precisa fechar aqui também.
    this.dropdownAberto = null;
    this.dropdownPosFixa = null;
    this.statusSubMenuAberto = null;
    if (this.pedidoSelecionado === nunota) {
      this.pedidoSelecionado = null;
      this.fecharFluxo();
    } else {
      this.pedidoSelecionado = nunota;
      await this._carregarFluxo(nunota);
    }
  }

  async focarPedido(nunota: number, abrirFluxo: boolean = false): Promise<void> {
    this.pedidoSelecionado = nunota;
    await this.buscar(false); // Garante que a lista foi carregada sem resetar a página prematuramente
    
    const idx = this.pedidosFiltrados.findIndex(p => p.nunota === nunota);
    if (idx >= 0) {
      this.paginaAtual = Math.floor(idx / this.itensPorPagina) + 1;
    }

    if (abrirFluxo) {
      await this._carregarFluxo(nunota);
    }
  }

  onImprimir(): void {
    if (this.pedidoSelecionado == null) return;
    this.imprimirPedido.emit(this.pedidoSelecionado);
  }

  constructor(
    private readonly gateway: SankhyaGatewayService,
    readonly empresaState: EmpresaStateService,
    private readonly permissaoAcesso: PermissaoAcessoService
  ) {}

  private _empresaSub?: Subscription;

  /** VISVEN: se false, só vê as próprias vendas (codVendLogado) em toda a tela. */
  private podeVerTodasVendas = true;
  private codVendLogado: string | number | null = null;

  ngOnInit(): void {
    const hoje = new Date();
    const de   = new Date();
    de.setDate(de.getDate() - 30);
    this.dtAte = this._fmtIso(hoje);
    this.dtDe  = this._fmtIso(de);

    this._carregarPermissaoVisualizacao().then(() => this.buscar());
    this.carregarMotivos();

    this._empresaSub = this.empresaState.empresaMudou.subscribe(() => {
      this.buscar();
    });
  }

  /** Carrega VISVEN e, quando false, o codVend do vendedor logado (para filtrar). */
  private async _carregarPermissaoVisualizacao(): Promise<void> {
    try {
      this.podeVerTodasVendas = await this.permissaoAcesso.podeVerTodasVendas();

      if (!this.podeVerTodasVendas) {
        const res: any = await firstValueFrom(this.gateway.buscarVendedorLogadoPedidoVenda());
        const body = res?.responseBody ?? res;
        this.codVendLogado = body?.vendedor?.codVend ?? null;
      }
    } catch (error) {
      console.warn('[PedidoVendaLista] Falha ao consultar permissao VISVEN:', error);
    }
  }

  ngOnDestroy(): void {
    this._empresaSub?.unsubscribe();
  }

  async carregarMotivos(): Promise<void> {
    this.carregandoMotivos = true;
    try {
      const res: any = await firstValueFrom(
        this.gateway.listarMotivosCancelamento('PEDIDO')
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        const lista: any[] = body.lista ?? [];
        this.motivosDisponiveis = lista
          .filter(m => {
            const a = (m.ativo ?? '').toLowerCase();
            return a !== 'não' && a !== 'nao' && a !== 'n' && a !== 'inativo' && a !== '';
          })
          .map(m => m.motivo as string);
      }
    } catch {
      // silencioso — usa campo livre como fallback
    } finally {
      this.carregandoMotivos = false;
    }
  }

  async buscar(resetPagina = true): Promise<void> {
    this.erro = '';
    this.erroCancelamento = '';
    this.carregando = true;
    
    if (resetPagina) {
      this.pedidos = [];
      this.paginaAtual = 1;
    }
    
    try {
      const codEmp = Number(this.empresaState.selecionada ?? 1);
      // VISVEN=false: restringe a busca (incluindo filtro por PN e por data) às
      // próprias vendas do vendedor logado; VISVEN=true: sem restrição (todas).
      const codVendFiltro = this.podeVerTodasVendas ? null : this.codVendLogado;
      const res: any = await firstValueFrom(
        this.gateway.listarPedidosVenda(codEmp, this._isoParaBr(this.dtDe), this._isoParaBr(this.dtAte), this.mostrarCancelados, this.termoBuscaPn, codVendFiltro)
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        this.pedidos = (body.lista ?? []).map((p: any) => this._normalizarObsInterna(p));
        if (!resetPagina) {
          if (this.paginaAtual > this.totalPaginas && this.totalPaginas > 0) {
            this.paginaAtual = this.totalPaginas;
          }
        }
      } else if (body?.sucesso === false || body?.sucesso === 'false' || body?.erro
                 || (res?.status != null && String(res.status) !== '1')) {
        this.erro = body?.erro ?? res?.statusMessage ?? 'Erro ao buscar pedidos.';
      } else {
        // Resposta sem erro e sem "sucesso" (ex.: empresa sem pedidos — lista vazia colapsada pelo serviço): tela vazia, sem mensagem.
        this.pedidos = [];
      }
    } catch (err: any) {
      this.erro = err?.message ?? 'Erro de comunicação.';
    } finally {
      this.carregando = false;
    }
  }

  /**
   * O addon (PedidoVendaGlobalSP.doListarPedidos) é externo a este repositório
   * — não temos como garantir com qual casing/nome ele devolve a coluna
   * AD_OBSINT (varia entre implementações). Se "obsInterna" (camelCase) não
   * vier, tenta as variações mais prováveis antes de mostrar vazio. Se
   * nenhuma bater, o dado simplesmente não está sendo enviado pelo addon —
   * precisa de ajuste do lado de lá, fora do alcance deste repositório.
   */
  private _normalizarObsInterna(p: any): PedidoLinha {
    if (p.obsInterna == null || p.obsInterna === '') {
      const alt = p.OBSINTERNA ?? p.obsinterna ?? p.OBS_INTERNA ?? p.obs_interna
        ?? p.AD_OBSINT ?? p.adObsint ?? p.adObsInt ?? p.obsInt ?? p.OBSINT ?? p.obsint
        ?? p.AD_OBSINTERNA ?? p.adObsInterna;
      if (alt != null) p.obsInterna = alt;
    }
    return p;
  }

  async abrirDetalhe(nunota: number): Promise<void> {
    this.detalhe = null;
    this.detalheAberto = true;
    this.detalheCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarDetalhesPedidoVenda(nunota)
      );
      const body = res?.responseBody ?? res;
      this.detalhe = (body?.sucesso === true || body?.sucesso === 'true') ? (body.detalhe ?? null) : null;
    } catch {
      this.detalhe = null;
    } finally {
      this.detalheCarregando = false;
    }
  }

  fecharDetalhe(): void {
    this.detalheAberto = false;
    this.detalhe = null;
  }

  // ── Ações ─────────────────────────────────────────────────

  onEditar(event: Event, nunota: number): void {
    event.stopPropagation();
    this.editarPedido.emit(nunota);
  }

  /** Duplo clique na linha — pedido do usuário: sempre abrir a tela cheia do
   *  pedido, em vez de só expandir os detalhes. Quando o pedido pode ser
   *  editado (podeEditar()), abre editável, como sempre. Quando não pode
   *  (autorizado/finalizado/etc.), abre a MESMA tela, mas o próprio
   *  <app-pedido-venda> já entra sozinho em modo visualização travado
   *  (modoSomenteLeitura, calculado a partir do GPL_STATUS do pedido ao
   *  carregar — ver pedido-venda.component#carregarPedido) — não precisa de
   *  nenhuma flag extra aqui, só garantir que a tela sempre abre. */
  onDblClickLinha(p: any): void {
    this.editarPedido.emit(p.nunota);
  }

  // ── Modal "Editar Dados da Venda" (cliente, endereço, aeronave, tipo
  // negociação e observações — sem tocar Itens/Comissionado) ──────────────
  mostrarModalCabecalho = false;
  nunotaParaEditarCabecalho: number | null = null;
  // true quando o modal foi aberto pelo botão "Finalizar Venda" (Status ▸
  // Finalizar Venda) — nesse modo, ao Salvar Alterações o componente
  // app-pedido-venda força GPL_STATUS='FINALIZADO' em vez de manter o valor
  // atual do pedido (ver [forcarFinalizarAoSalvar] no template).
  finalizandoVenda = false;

  onEditarCabecalho(event: Event, p: any): void {
    event.stopPropagation();
    if (!this.podeEditarCabecalho(p)) return;
    this.fecharDetalhe();
    this.fecharDropdown();
    this.nunotaParaEditarCabecalho = p.nunota;
    this.finalizandoVenda = false;
    this.mostrarModalCabecalho = true;
  }

  /** GPL_STATUS em que "Finalizar Venda" pode ficar habilitado — só a partir
   *  de Pronto (após a Conferência de Estoque terminar), a pedido do usuário. */
  podeFinalizarGpl(p: PedidoLinha): boolean {
    return (p.gplStatus || '').toUpperCase() === 'PRONTO';
  }

  /** Abre o mesmo modal "Editar Dados da Venda", mas em modo "finalizar":
   *  ao clicar em Salvar Alterações lá dentro, o GPL_STATUS vira FINALIZADO
   *  (ver finalizandoVenda / [forcarFinalizarAoSalvar]). */
  onSolicitarFinalizarVenda(event: Event, p: PedidoLinha): void {
    event.stopPropagation();
    if (!this.podeFinalizarGpl(p)) return;
    this.fecharDetalhe();
    this.fecharDropdown();
    this.nunotaParaEditarCabecalho = p.nunota;
    this.finalizandoVenda = true;
    this.mostrarModalCabecalho = true;
  }

  fecharModalCabecalho(): void {
    this.mostrarModalCabecalho = false;
    this.nunotaParaEditarCabecalho = null;
    this.finalizandoVenda = false;
    this.buscar(false);
  }

  onSolicitarDuplicar(event: Event, nunota: number): void {
    event.stopPropagation();
    this.fecharDetalhe();
    this.fecharDropdown();
    this.solicitarDuplicar.emit(nunota);
  }

  onSolicitarDividir(event: Event, p: PedidoLinha): void {
    event.stopPropagation();
    if (!p.podeDesm) return;
    this.fecharDetalhe();
    this.fecharDropdown();
    this.solicitarDividir.emit(p.nunota);
  }

  onSolicitarTransferir(event: Event, nunota: number, codemp: number): void {
    event.stopPropagation();
    this.fecharDetalhe();
    this.fecharDropdown();
    this.solicitarTransferir.emit({ nunota, codemp });
  }

  onSolicitarGerarPedidoCompra(event: Event, nunota: number): void {
    event.stopPropagation();
    this.fecharDetalhe();
    this.fecharDropdown();
    this.solicitarGerarPedidoCompra.emit(nunota);
  }

  onSolicitarFluxo(event: Event, nunota: number): void {
    event.stopPropagation();
    this.fecharDropdown();
    this.solicitarFluxo.emit(nunota);
  }

  onSolicitarTransporte(event: Event, nunota: number): void {
    event.stopPropagation();
    this.fecharDropdown();
    this.solicitarTransporte.emit(nunota);
  }

  onSolicitarAnexos(event: Event, nunota: number): void {
    event.stopPropagation();
    this.fecharDropdown();
    this.solicitarAnexos.emit(nunota);
  }

  onSolicitarAutorizar(event: Event, p: PedidoLinha): void {
    event.stopPropagation();
    this.fecharDropdown();
    if (!this.podeAutorizar(p)) {
      this.avisoAutorizarBloqueado.emit(
        `Pedido #${p.nunota} não pode ser autorizado agora: ${this.tituloAutorizarBloqueado(p)}`
      );
      return;
    }
    this.solicitarAutorizar.emit(p.nunota);
  }

  /** Mesmo texto usado no tooltip do botão Autorizar quando desabilitado —
   *  ver [title] em pedido-venda-lista.component.html. */
  tituloAutorizarBloqueado(p: PedidoLinha): string {
    const topElegivel = this.ehOrcamento(p) || p.codTipOper === 1001 || p.codTipOper === 1152;
    if (!topElegivel) {
      return 'disponível apenas para Orçamentos, Pedidos de Venda ou Transferências (TOP 1000/1001/1152)';
    }
    return `só é possível autorizar pedidos com status Aberto (status atual: ${p.gplStatus || 'Aberto'})`;
  }

  /** "Excluir" — cancelamento nativo do Sankhya (remove de TGFCAB/TGFITE,
   *  estorna financeiro/estoque, grava em TGFCAN). Era o antigo "Cancelar". */
  onClickExcluir(event: Event, p: PedidoLinha): void {
    // Sankhya só permite cancelar notas Liberadas (STATUSNOTA='L').
    if (p.status === 'Atendimento' || p.status === 'Atendido') return;
    this.onSolicitarCancelamento(event, p.nunota);
    this.fecharDropdown();
  }

  onSolicitarCancelamento(event: Event, nunota: number): void {
    event.stopPropagation();
    this.confirmandoCancelamento = nunota;
    this.motivoCancelamento = this.motivosDisponiveis[0] ?? '';
    this.erroCancelamento = '';
  }

  cancelarConfirmacao(): void {
    this.confirmandoCancelamento = null;
    this.motivoCancelamento = '';
  }

  async confirmarCancelamento(): Promise<void> {
    const nunota = this.confirmandoCancelamento;
    if (!nunota) return;

    this.cancelando = nunota;
    this.confirmandoCancelamento = null;
    this.erroCancelamento = '';

    try {
      const res: any = await firstValueFrom(
        this.gateway.cancelarPedidoVenda(nunota, this.motivoCancelamento)
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        await this.buscar();
      } else {
        this.erroCancelamento = body?.erro ?? 'Erro ao cancelar pedido.';
      }
    } catch (err: any) {
      this.erroCancelamento = err?.message ?? 'Erro de comunicação.';
    } finally {
      this.cancelando = null;
    }
  }

  // ── Cancelar (leve) / Estornar — só mexem no GPL_STATUS (e, no caso de
  // Estornar um Autorizado, também tentam voltar o TOP para Orçamento).
  // Não usam o cancelamento nativo do Sankhya — isso é o Excluir.
  // A gravação em si acontece em segundo plano na tela de Pedido de Venda
  // (reaproveitando toda a lógica de carregar/gravar já existente), então
  // aqui só emitimos o pedido — quem executa é o gateway.
  // Cancelar (leve) só pode enquanto o pedido ainda é Orçamento (TOP 1000).
  // Uma vez que a TOP já virou Pedido de Venda (1001), o Cancelar leve não é
  // mais permitido — o usuário precisa passar pelo Excluir (cancelamento
  // nativo do Sankhya) nesse ponto.
  podeCancelarGpl(p: PedidoLinha): boolean {
    const status = (p.gplStatus || '').toUpperCase();
    return this.ehOrcamento(p) && (status === 'ABERTO' || status === '');
  }

  podeEstornarGpl(p: PedidoLinha): boolean {
    const status = (p.gplStatus || '').toUpperCase();
    return status === 'CANCELADO' || status === 'AUTORIZADO' || status === 'FINALIZADO';
  }

  /** Estornar de FINALIZADO volta pra PRONTO (mesmo status que a Conferência
   *  de Estoque grava ao terminar — ver onSolicitarFinalizarConferenciaComStatus
   *  em gateway.component.ts); Cancelado/Autorizado voltam pra ABERTO, como já era. */
  private _statusAlvoEstornar(p: PedidoLinha): string {
    return (p.gplStatus || '').toUpperCase() === 'FINALIZADO' ? 'PRONTO' : 'ABERTO';
  }

  tituloEstornarGpl(p: PedidoLinha): string {
    if (!this.podeEstornarGpl(p)) {
      return 'Só é possível estornar pedidos Cancelados, Autorizados ou Finalizados';
    }
    return this._statusAlvoEstornar(p) === 'PRONTO'
      ? 'Estornar — volta o status para Pronto'
      : 'Estornar — volta o status para Aberto';
  }

  onClickCancelarGpl(event: Event, p: PedidoLinha): void {
    event.stopPropagation();
    if (!this.podeCancelarGpl(p)) return;
    this.fecharDropdown();
    this.solicitarAlterarStatusGpl.emit({ nunota: p.nunota, novoGplStatus: 'CANCELADO' });
  }

  onClickEstornarGpl(event: Event, p: PedidoLinha): void {
    event.stopPropagation();
    if (!this.podeEstornarGpl(p)) return;
    this.fecharDropdown();
    // Antes forçava a TOP de volta para 1000 ao estornar um AUTORIZADO
    // (assumindo que essa é sempre a TOP de "Orçamento"). Isso quebrava em
    // pedidos com tabela de preço em moeda (ex.: Dólar) cuja TOP 1000 não
    // está configurada para operações em moeda nesse Sankhya — erro
    // "Configurações incoerentes". Estornar agora só reverte o GPL_STATUS
    // (campo nosso, controla a tela) e não mexe na TOP, que o Autorizar
    // nativo do Sankhya já validou como compatível. Estornar um FINALIZADO
    // segue a mesma regra — só o GPL_STATUS, sem tocar nenhuma tabela de
    // separação/conferência/logística (essas já foram encerradas antes de
    // chegar em FINALIZADO, então não há nada delas pra desfazer aqui).
    this.solicitarAlterarStatusGpl.emit({ nunota: p.nunota, novoGplStatus: this._statusAlvoEstornar(p) });
  }

  // ── Helpers ───────────────────────────────────────────────

  empresaLabel(p: PedidoLinha): string {
    return p.codemp ? `${p.codemp} — ${p.empresa}` : p.empresa;
  }

  ehCancelado(p: any): boolean {
    return p.status === 'Cancelado' || p.status === 'Cancelada';
  }

  podeEditar(p: any): boolean {
    const status = (p.gplStatus || '').toUpperCase();
    return status === 'ABERTO' || status === 'PENDENTE' || !status;
  }

  /** GPL_STATUS em que "Desmembrar Venda" pode ficar habilitado. Separação
   *  Total e Logística NÃO entram aqui de propósito — nesses estágios os itens
   *  já foram conferidos/embalados como um lote físico único, então desmembrar
   *  deixaria de bater com o que já está fisicamente separado. "SEPARACAO"
   *  (em andamento) agora é permitido: o backend migra o vínculo de
   *  separação/serial (GPL_SEPARACAO_ITENS/TGFSER) dos itens pro pedido novo
   *  ou pro pedido original conforme o caso (ver PedidoVendaRepository.
   *  dividirPedido/migrarReservaItensLote) — mas isso só resolve a
   *  BOOKKEEPING (o sistema continua sabendo o que já foi separado); a
   *  reconciliação física (qual pilha no chão pertence a qual pedido/tag)
   *  ainda é manual, então avise o separador ao usar. "ESTOQUE" ainda não
   *  existe como GPL_STATUS hoje, mas já fica liberado pra quando esse status
   *  for implementado. */
  /** "Editar Dados da Venda" é bloqueado apenas nesses status — em todos os
   *  demais pode editar normalmente. FATURADO ainda não existe no sistema
   *  (status futuro a ser implementado), mas já entra no bloqueio agora.
   *  CANCELADO entra aqui pelo mesmo motivo de Clonar/Gerar Pedido de
   *  Compra/Transporte/Anexos abaixo -- não faz sentido mexer em nenhum
   *  desses dados de um pedido cancelado. */
  private readonly EDITAR_CABECALHO_STATUS_BLOQUEADOS = ['FINALIZADO', 'FATURADO', 'CANCELADO'];

  podeEditarCabecalho(p: any): boolean {
    const status = (p.gplStatus || 'ABERTO').toUpperCase();
    return !this.EDITAR_CABECALHO_STATUS_BLOQUEADOS.includes(status);
  }

  tituloEditarCabecalhoBloqueado(p: any): string {
    const status = (p.gplStatus || '').toUpperCase();
    if (status === 'CANCELADO') {
      return 'Não é possível editar os dados de vendas: este pedido está Cancelado.';
    }
    return `Não é possível editar os dados de vendas com status Finalizado ou Faturado (status atual: ${p.gplStatus || 'Aberto'})`;
  }

  /** Clonar Venda, Gerar Pedido de Compra, Dados do Transporte e Anexos
   *  ficam bloqueados quando o pedido está CANCELADO -- é um pedido morto,
   *  não faz sentido duplicá-lo, gerar compra a partir dele, editar o
   *  transporte ou anexar documentos nele. (Desmembrar e Transferir já
   *  ficam bloqueados nesse status pelas próprias regras deles — ver
   *  podeDesmembrarStatus/DESMEMBRAR_STATUS_PERMITIDOS e o check de
   *  gplStatus === 'ABERTO' do item-transferir.) */
  podeAcessarSeNaoCancelado(p: any): boolean {
    return (p.gplStatus || '').toUpperCase() !== 'CANCELADO';
  }

  tituloBloqueadoPorCancelado(acao: string): string {
    return `${acao} não está disponível: este pedido está Cancelado.`;
  }

  private readonly DESMEMBRAR_STATUS_PERMITIDOS = ['ABERTO', 'AUTORIZADO', 'CONFERENCIA', 'ESTOQUE', 'SEPARACAO'];

  /** Rótulos amigáveis (na mesma ordem de DESMEMBRAR_STATUS_PERMITIDOS) para a mensagem do tooltip. */
  private readonly DESMEMBRAR_STATUS_PERMITIDOS_LABEL = 'Aberto, Autorizado, Conferência, Estoque ou Separação';

  podeDesmembrarStatus(p: any): boolean {
    const status = (p.gplStatus || 'ABERTO').toUpperCase();
    return this.DESMEMBRAR_STATUS_PERMITIDOS.includes(status);
  }

  tituloDesmembrarBloqueado(p: any): string {
    return `Só é possível desmembrar vendas com status ${this.DESMEMBRAR_STATUS_PERMITIDOS_LABEL} (status atual: ${p.gplStatus || 'Aberto'})`;
  }

  /** Retorna true quando a TOP do pedido é Orçamento (codTipOper 1000) */
  ehOrcamento(p: PedidoLinha): boolean {
    return p.codTipOper === 1000;
  }

  /** Autorizar vale tanto para um Orçamento (TOP 1000) quanto para um pedido
   *  que já é Pedido de Venda (TOP 1001) com GPL_STATUS=ABERTO — esse
   *  segundo caso acontece depois de um Estornar (que só reseta o
   *  GPL_STATUS, sem voltar a TOP para Orçamento). O backend
   *  (autorizarPedido) já tem um caminho curto pra isso: se a TOP já é 1001,
   *  só atualiza o GPL_STATUS, sem tentar converter de novo.
   *  Só fica habilitado com GPL_STATUS=ABERTO (ou vazio, equivalente) — em
   *  qualquer outro status (Autorizado, Pendente, Separação, Conferência,
   *  Logística, Pronto, Finalizado, Cancelado etc.) o Autorizar fica
   *  desabilitado, mesmo que a TOP ainda seja Orçamento. */
  podeAutorizar(p: PedidoLinha): boolean {
    // codTipOper === 1152: Venda de Transferência (AD_CATEGORIA=TRANSFERENCIA) —
    // nasce direto nessa TOP (nunca passa por Orçamento/1000), mas segue o mesmo
    // fluxo de Autorização de um Pedido de Venda normal (ver autorizarPedido no
    // GPL/model e onSolicitarAutorizarPedido em gateway.component.ts).
    const topElegivel = this.ehOrcamento(p) || p.codTipOper === 1001 || p.codTipOper === 1152;
    const status = (p.gplStatus || '').toUpperCase();
    return topElegivel && (status === 'ABERTO' || status === '');
  }

  statusClass(status: string): string {
    switch (status) {
      case 'Liberado':     return 'status-liberado';
      case 'Atendimento':  return 'status-atendimento';
      case 'Atendido':     return 'status-atendido';
      case 'Pendente':     return 'status-pendente';
      case 'Cancelado':    return 'status-cancelado';
      default:             return 'status-outro';
    }
  }

  fmtDocumento(doc: string | null | undefined): string {
    const d = (doc ?? '').replace(/\D/g, '');
    if (d.length === 14) {
      return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    if (d.length === 11) {
      return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
    return doc || '—';
  }

  fmtMoeda(v: number | null | undefined): string {
    if (v == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' }).format(v);
  }

  /** Formata Date → YYYY-MM-DD (formato do input type="date") */
  private _fmtIso(d: Date): string {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  /** Converte YYYY-MM-DD → DD/MM/YYYY para enviar ao backend */
  private _isoParaBr(iso: string): string {
    if (!iso || iso.length !== 10) return iso;
    const [yyyy, mm, dd] = iso.split('-');
    return `${dd}/${mm}/${yyyy}`;
  }

  // ── Fluxo (Inline) ────────────────────────────────────────

  private async _carregarFluxo(nunota: number): Promise<void> {
    this.fecharFluxo(); // Limpa o estado anterior
    
    try {
      const res: any = await firstValueFrom(this.gateway.buscarFluxoDivisao(nunota));
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        const nos = body.fluxo ?? [];
        if (nos.length > 1) {
          const todosNos: FluxoNode[] = nos.map((n: any) => ({
            nunota:       Number(n.nunota),
            nunotaOrig:   n.nunotaPai != null ? Number(n.nunotaPai) : null,
            ehSelecionada: Number(n.nunota) === nunota,
            ehRaiz:        !!n.ehRaiz,
            dtmov:         n.dtmov   ?? '',
            status:        n.status  ?? 'L',
            nomeparc:      n.nomeparc ?? '—',
            codemp:        Number(n.codemp) || 0,
            filhos:        []
          }));

          const map = new Map<number, FluxoNode>();
          todosNos.forEach(n => map.set(n.nunota, n));

          const raizes: FluxoNode[] = [];
          todosNos.forEach(n => {
            if (n.nunotaOrig && map.has(n.nunotaOrig)) {
              map.get(n.nunotaOrig)!.filhos.push(n);
            } else {
              raizes.push(n);
            }
          });
          
          this.fluxoNos = todosNos;
          this.fluxoRaizes = raizes;
          this.fluxoSelecionado = nunota; // Somente exibe se houver cadeia válida
        }
      }
    } catch (err: any) {
      // Falha silenciosa para não quebrar a navegação caso a API falhe
    }
  }

  /** Clique num card do fluxo inline: troca de filial se necessário, depois foca a nota. */
  async navegarFluxoInline(nunota: number, codemp: number = 0): Promise<void> {
    if (codemp && String(codemp) !== this.empresaState.selecionada) {
      this.empresaState.selecionada = String(codemp);
      await new Promise(resolve => setTimeout(resolve, 120)); // aguarda lista recarregar
    }
    await this.focarPedido(nunota, true);
  }

  fecharFluxo(event?: Event): void {
    if (event) event.stopPropagation();
    this.fluxoSelecionado = null;
    this.fluxoNos = [];
  }

  /** Filtra a lista pelos pedidos do fluxo inline atualmente expandido. */
  filtrarVendasDoFluxoInline(): void {
    const nunotas = this.fluxoNos.map(n => n.nunota);
    const label   = `fluxo da venda #${this.fluxoSelecionado}`;
    this.aplicarFiltroFluxo(nunotas, label);
    // Fecha o painel inline após aplicar o filtro
    this.fluxoSelecionado = null;
    this.fluxoNos         = [];
  }

  fluxoStatusLabel(status: string): string {
    switch (status) {
      case 'L': return 'Liberado';
      case 'A': return 'Aberto';
      case 'P': return 'Pendente';
      case 'C': return 'Cancelado';
      default:  return status || 'Aberto';
    }
  }

  fluxoStatusClass(status: string): string {
    switch (status) {
      case 'L': return 'fluxo-status-lib';
      case 'A': return 'fluxo-status-abe';
      case 'P': return 'fluxo-status-pen';
      case 'C': return 'fluxo-status-can';
      default:  return 'fluxo-status-abe';
    }
  }

  fmtQtd(valor: any): string {
    if (valor == null || valor === '') return '0';
    let numStr = String(valor).replace(/,/g, '.');
    let num = parseFloat(numStr);
    if (isNaN(num)) return String(valor);

    if (Number.isFinite(num) && Math.abs(num - Math.round(num)) < 1e-6) {
      return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
    }
    return num.toLocaleString('pt-BR', { maximumFractionDigits: 4 });
  }
}




